import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

/**
 * 🧾 Reporte de compras por formas de pago
 *
 * Backend esperado: dateFrom, dateTo (todas las sucursales)
 */
export const purchaseByPaymentMethodReportFilters: UniversalFilterConfig[] = [
  {
    name: "dateFrom",
    label: "Fecha Desde",
    type: "date",
    iconKey: "calendar",
  },
  {
    name: "dateTo",
    label: "Fecha Hasta",
    type: "date",
    iconKey: "calendar",
  },
];
